// Libs
import React from 'react';
import { Grid } from '@mui/material';

// Components
import Reorder from '../../../../Button/ReorderButton/ReorderButton';

const REORDER_PADDING_RIGHT_MOBILE = 1.25;
const REORDER_PADDING_RIGHT = 2.5;

const OrderCardReorderColumn = ({
  order,
  isDistro,
  isMobileMode,
  isTabletMode,
  canReorder,
  onReorder,
  gridPropValues,
  classes,
}) => (
  <Grid
    className={classes.reorderContainer}
    item
    maxWidth={gridPropValues({
      lgSize: 12,
      mdSize: 6,
      unit: '%',
    })}
    flexBasis={gridPropValues({
      lgSize: 3,
      mdSize: 6,
      unit: '%',
    })}
    container
    order={8}
    pr={isMobileMode ? REORDER_PADDING_RIGHT_MOBILE : REORDER_PADDING_RIGHT}
    alignContent="end"
    justifyContent="right">
    {order?.address && (
      <Reorder
        disabled={!canReorder}
        order={order}
        onClick={onReorder}
        className={classes.reorderButton}
        inTable={true}
      />
    )}
    {isDistro && isTabletMode && !isMobileMode && (
      <span className={classes.captionSmall} data-testid="distro-label">
        Distro
      </span>
    )}
  </Grid>
);

export default OrderCardReorderColumn;
